import {createEntityAdapter} from '@reduxjs/toolkit';

export const filterAdapter = createEntityAdapter({
	selectId: (item) => item.id
});
